var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSaved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.5 5.75c-.41421 0-.75.33579-.75.75v12c0 .4142.33579.75.75.75h11c.4142 0 .75-.3358.75-.75v-4.5c0-.4142.3358-.75.75-.75s.75.3358.75.75v4.5c0 1.2426-1.0074 2.25-2.25 2.25h-11c-1.24264 0-2.25-1.0074-2.25-2.25v-12c0-1.24264 1.00736-2.25 2.25-2.25h4.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 4c0-.55228.4477-1 1-1h6c.5523 0 1 .44772 1 1v7.52c0 .6098-.6962.9579-1.184.592l-2.216-1.662c-.3556-.2667-.8444-.2667-1.2 0l-2.216 1.662c-.4878.3659-1.184.0178-1.184-.592z"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.25 8c0-.41421.33579-.75.75-.75h2.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-2.5c-.41421 0-.75-.33579-.75-.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.25 11c0-.4142.33579-.75.75-.75h1c.41421 0 .75.3358.75.75s-.33579.75-.75.75h-1c-.41421 0-.75-.3358-.75-.75z"
  })))));
}

export default SvgSaved;